

import React from "react";
import TypedText from "./typed";
import { Link } from "react-router-dom";

const Intro = () => {
  return (
    <section className="w-full min-h-screen flex items-center justify-center bg-white py-10 px-4 ">
      <div className="w-full max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10">

        <div className="w-full md:w-1/2 flex justify-center items-center">
          <div className="w-full max-w-[320px] sm:max-w-[450px] md:max-w-full aspect-square">
            <dotlottie-wc
              src="https://lottie.host/d8037954-4c88-42de-a59a-887d0000a995/lqoqELQ9OK.lottie"
              style={{ width: '100%', height: '100%' }}
              background="transparent"
              speed="1"
              autoplay
              loop
            ></dotlottie-wc>
          </div>
        </div>

        <div className="w-full md:w-1/2 flex flex-col text-center md:text-left items-center md:items-start space-y-8">
          <div className="">
            <h1 className="text-xl sm:text-4xl font-black text-slate-900 leading-tight">
              Hello, <br /> This is <span className="text-secondary uppercase">Digital Marketing</span> Agency
            </h1>

            <div className="text-2xl sm:text-2xl md:text-2xl font-bold text-slate-600 min-h-[70px] mt-4 flex items-center justify-center md:justify-start">
              <TypedText />
            </div>
          </div>

          <p className="text-slate-500 text-lg max-w-md">
            We help brands grow by turning clicks into loyal customers.
          </p>

          <div className="w-full sm:w-auto">
            <button className="
              relative w-full sm:w-auto px-12 py-5 
              bg-orange-500 text-white font-black  tracking-wide uppercase
              rounded-2xl
              border-b-[6px] border-orange-700
              hover:border-b-[2px] hover:translate-y-[4px]
              active:border-b-0 active:translate-y-[6px]
              transition-all duration-100 ease-in-out
              shadow-xl
              flex items-center justify-center gap-3
              group
            ">

              <Link to='/contact'>
                Get in Touch
              </Link>
              <span className="group-hover:translate-x-2 transition-transform duration-300">
                →
              </span>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Intro;